import { type IReactionDisposer, makeAutoObservable, reaction } from 'mobx'
import { type ChatbotActionNote } from 'entities/Chatbot'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { EmojiAction, EnumVariantMessageField, MessageFieldStore } from 'widgets/MessageField'

export class ChatbotActionNoteStore {
  private readonly _disposeNoteReaction: IReactionDisposer | null = null
  private readonly _note: MessageFieldStore

  constructor(private _model: ChatbotActionNote, private _entities: IEntitiesStore) {
    makeAutoObservable(this)

    this._note = new MessageFieldStore(
      {
        placeholder: 'Write internal note',
        noCounter: true,
        showActionsItems: 2,
        variant: EnumVariantMessageField.Note,
        resetOnUnmount: false,
        textLimit: {
          maxLength: 255,
          message: 'Note can contain max 255 characters',
        },
        makeActions: () => [
          {
            iconButtonComponent: <EmojiAction />,
          },
        ],
      },
      this._entities
    )

    this._disposeNoteReaction = reaction(
      () => this._note.text,
      (text) => {
        const prevText = this._model.note
        const textIsSame = prevText === text

        if (textIsSame) return

        this._model.sync(text)
      }
    )
  }

  syncNote = () => {
    this._note.setMessageData({
      message: this._model.note,
      attachments: [],
      isReset: false,
      isReplace: true,
      isFocus: false,
    })
  }

  dispose = () => {
    this._disposeNoteReaction?.()
  }

  get note() {
    return this._note
  }
}
